import { useQuery } from 'react-query'
import { defaultPagination } from '~/utils/defaultPagination'
import { IAircraft, IPaginated } from '~/utils/types'
import { aircraftKeys } from '.'
import { listPaginatedAssets } from '../data/aircraftApi'

export const useListPaginatedAircraft = (pagination = defaultPagination(), query?: string) => {
  return useQuery<IPaginated<IAircraft>>({
    queryKey: aircraftKeys.list(pagination, query).queryKey,
    queryFn: () => listPaginatedAssets({ pagination, query }),
  })
}
